<template>
  <div v-if="!chatStore.loading" class="cookie-consent">
    <h3 class="cookie-consent__title">{{ $t('cookie_consent.title') }}</h3>

    <div class="cookie-consent__item">
      <p>{{ $t('cookie_consent.necessary') }}</p>
      <t-switch v-model="selectedCookies" readonly class="ml-4" name="necessary"></t-switch>
    </div>

    <div class="cookie-consent__item">
      <p>{{ $t('cookie_consent.functional') }}</p>
      <t-switch v-model="selectedCookies" class="ml-4" name="functional"></t-switch>
    </div>

    <div class="cookie-consent__item">
      <p>{{ $t('cookie_consent.performance') }}</p>
      <t-switch v-model="selectedCookies" class="ml-4" name="performance"></t-switch>
    </div>

    <div class="cookie-consent__item">
      <p>{{ $t('cookie_consent.advertising') }}</p>
      <t-switch v-model="selectedCookies" class="ml-4" name="advertising"></t-switch>
    </div>

    <div class="flex mt-2">
      <theme-button class="w-full" outline @click="$emit('accept-all')">{{
        $t('cookie_consent.accept_all')
      }}</theme-button>
      <theme-button class="w-full ml-1" @click="$emit('confirm', selectedCookies)">{{
        $t('cookie_consent.confirm')
      }}</theme-button>
    </div>
  </div>
</template>

<script>
import ThemeButton from 'javascript/Common/ThemeButton'
import { useChatStore } from 'Store/chat'
import { privacyPolicyURLForJA, privacyPolicyURL, CookieTypes } from 'javascript/Constants'
export default {
  name: 'CookieConsent',
  components: { ThemeButton },

  setup() {
    return {
      chatStore: useChatStore()
    }
  },

  data() {
    return {
      selectedCookies: Object.values(CookieTypes)
    }
  },

  computed: {
    privacyPolicyLink() {
      return this.$i18n.locale === 'ja' ? privacyPolicyURLForJA : privacyPolicyURL
    }
  }
}
</script>
